import { render, staticRenderFns } from "./checkGoodsLabels.vue?vue&type=template&id=9c113720&scoped=true&"
import script from "./checkGoodsLabels.vue?vue&type=script&lang=js&"
export * from "./checkGoodsLabels.vue?vue&type=script&lang=js&"
import style0 from "./checkGoodsLabels.vue?vue&type=style&index=0&id=9c113720&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c113720",
  null
  
)

component.options.__file = "checkGoodsLabels.vue"
export default component.exports